<template>
  <base-slide-over ref="messagesSlideover" title="Messages" size="md">
    <timeline id="messages" ref="messages" :items="messages" :isLoading="isLoading" class="tw-h-full" />
    <template #fixed-bottom>
      <div class="tw-flex">
        <base-text-field @keyup.enter="send" v-model="newMessage" class="tw-flex-grow tw-px-2 tw-py-2" /><base-button class="tw-flex-initial tw-my-auto tw-mx-2" @click="send">
          <template v-slot:icon>
            <send-icon /> </template
        ></base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import Timeline from "@/components/Timeline/Timeline";
import { SendIcon } from "@/assets/svgs";

export default {
  name: "MessagesSlideover",
  props: { userId: String },
  components: { Timeline, SendIcon },
  data() {
    return {
      businessId: null,
      todoItemId: null,
      messages: [],
      isLoading: false,
      newMessage: null,
    };
  },
  computed: {
    ...mapGetters("cognito", ["id", "name"]),
  },
  methods: {
    show(businessId, todoItemId) {
      this.businessId = businessId;
      this.todoItemId = todoItemId;
      this.loadMessages();
      this.$refs.messagesSlideover.show();
    },
    hide() {
      this.reset();
      this.$refs.messagesSlideover.hide();
    },
    reset() {
      this.todoItemId = null;
      this.messages = [];
      this.newMessage = null;
    },
    scrollToEnd() {
      this.delay(100).then(() => {
        this.$refs.messagesSlideover.scrollContentToBottom();
      });
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    loadMessages() {
      this.isLoading = true;
      let url = `/users/${this.userId}/cases/${this.todoItemId}/notes`;

      this.$axios
        .get(url)
        .then((res) => {
          this.messages = this.transformData(res.data);
          this.$nextTick(() => {
            this.scrollToEnd();
          });
        })
        .catch((err) => {
          console.log(err);
          debugger;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    send() {
      if (this.newMessage) {
        this.messages.push({
          todoItemNoteId: null,
          todoItemId: this.todoItemId,
          value: this.newMessage,
          insertDate: new Date(),
          insertBy: this.id,
          insertByName: this.name,
          subheading: "Jul 07 11:07pm",
          date: new Date(),
          orientation: "right",
          iconName: "comment",
          title: this.name,
          textValue: this.newMessage,
        });

        this.$emit("sendMessage", { todoItemId: this.todoItemId, message: this.newMessage });
        this.newMessage = null;
        this.scrollToEnd();
      }
    },
    transformData(items) {
      var formattedItems = [];
      items.forEach((item) => {
        item.subheading = new moment.utc(item.insertDate).local().format("MMM DD h:mma");
        item.date = new Date(item.insertDate);

        switch (item.insertBy) {
          case this.id:
            item.orientation = "right";
            item.iconName = "comment";
            break;
          default:
            item.orientation = "left";
            item.iconName = "comment";
        }

        item.title = item.insertByName;
        item.textValue = item.value;

        formattedItems.push(item);
      });

      return formattedItems.sort((a, b) => Number(a.date) - Number(b.date));
    },
  },
};
</script>
